import angular from 'angular';

import { r2a } from '@/react-tools/react2angular';
import { AccessTable } from '@/react/kubernetes/cluster/RegistryAccessView/AccessTable';
import { withCurrentUser } from '@/react-tools/withCurrentUser';
import { withUIRouter } from '@/react-tools/withUIRouter';

export const registriesModule = angular
  .module('portainer.kubernetes.react.components.registries', [])
  .component(
    'kubeRegistryAccessTable',
    r2a(withCurrentUser(withUIRouter(AccessTable)), [
      'dataset',
      'onRemove',
      'registryPolicy',
    ])
  ).name;
